import React from 'react'

import CSSModules from 'react-css-modules'
import styles from './style.module.scss'

import { MonthlyWorkReportDetail, MonthlyWorkReportDetailDailyWorkReports } from 'javascripts/api/generated'


interface StatusInterface {
  'active': string,
  'waiting_acceptance': string,
  'accepted': string,
  'suspending_acceptance': string,
  'waiting_cancellation_agreement': string,
}

type Status = keyof StatusInterface



const ClientMonthlyWorkReportDetailSheet: React.FC<{ monthlyWorkReport: MonthlyWorkReportDetail }> = CSSModules<React.FC<{ monthlyWorkReport: MonthlyWorkReportDetail }>>((props) => {
  const generateDatesForMonth = (yyyymm: string): string[] => {
    const year = parseInt(yyyymm.slice(0, 4), 10)
    const month = parseInt(yyyymm.slice(4, 6), 10)

    const startDate = new Date(year, month - 1, 1)
    const endDate = new Date(year, month, 0)

    const dates: string[] = []
    for (let day = startDate; day <= endDate; day.setDate(day.getDate() + 1)) {
      dates.push(toISOStringWithTimezone(new Date(day)))
    }
    return dates
  }

  const toISOStringWithTimezone = (date: Date): string => {
    const pad = function (str: string): string {
      return ('0' + str).slice(-2)
    }
    const year = (date.getFullYear()).toString()
    const month = pad((date.getMonth() + 1).toString())
    const day = pad(date.getDate().toString())
    return `${year}-${month}-${day}`
  }

  const formatDate = (dateString: string | number | Date): string => {
    const date = new Date(dateString)
    const day = date.getDate()
    const weekday = new Intl.DateTimeFormat('ja-JP', { weekday: 'short' }).format(date)
    return `${day}日（${weekday}）`
  }

  const formatTime = (isoString: string): string => {
    const date = new Date(isoString)
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    return `${hours}:${minutes}`
  }

  const formatMinutes = (totalMinutes: number): string => {
    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60

    let formattedTime = ''
    if (hours > 0) {
      formattedTime += `${hours}時間`
    }
    if (minutes > 0) {
      formattedTime += `${minutes}分`
    }

    return formattedTime
  }

  const getDataRecordClassName = (dailyWorkReport: MonthlyWorkReportDetailDailyWorkReports): string => {
    return (
        dailyWorkReport.breaktimeMinutes == null
        && dailyWorkReport.dailyStatus == 'workday'
        && dailyWorkReport.dayWorkingMinutes == 0
    ) ? 'table-no-data-item' : 'table-data-item'
  }

  const mergedReports = (dates: string[], dailyWorkReports: MonthlyWorkReportDetailDailyWorkReports[]): MonthlyWorkReportDetailDailyWorkReports[] => {
    const results: MonthlyWorkReportDetailDailyWorkReports[] = []
    dates.map(date => {
      const report = dailyWorkReports.find((report: MonthlyWorkReportDetailDailyWorkReports) => report.reportOn === date)
      results[date] = (report || { breaktimeMinutes: null, dailyStatus: 'workday', dayWorkingMinutes: 0, description: '', id: 0, reportOn: date, workEndedAt: null, workStartedAt: null })
    })
    return results
  }


  const renderDescription = (report: MonthlyWorkReportDetailDailyWorkReports): React.ReactNode => {
    if (report.dailyStatus === 'holiday' && report.description) {
      return `稼働なし（${report.description}）`;
    } else if (report.dailyStatus === 'workday' && report.description) {
      return report.description.split('\n').map((line, index) => (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      ));
    } else if (report.dailyStatus === 'holiday' && !report.description) {
      return '稼働なし';
    } else {
      return '-';
    }
  }

  const dailyReports = (targetMonth: string, dailyWorkReports: MonthlyWorkReportDetailDailyWorkReports[]) => {
    const reports = mergedReports(generateDatesForMonth(targetMonth),dailyWorkReports)
    const sortedDates = Object.keys(reports).sort()
    return sortedDates.map((date: string | number) => {
      const report: MonthlyWorkReportDetailDailyWorkReports = reports[date]
      const dataRecordClassName = getDataRecordClassName(report)
      return (
          <tr key={date}>
            <td styleName={dataRecordClassName}>{formatDate(report.reportOn)}</td>
            <td styleName={dataRecordClassName}>
              {report.workStartedAt ? formatTime(report.workStartedAt) : '-'}
            </td>
            <td styleName={dataRecordClassName}>
              {report.workEndedAt ? formatTime(report.workEndedAt) : '-'}
            </td>
            <td styleName={dataRecordClassName}>
              {report.breaktimeMinutes ? `${report.breaktimeMinutes}分` : '-'}
            </td>
            <td styleName={dataRecordClassName}>
              {report.dayWorkingMinutes ? formatMinutes(report.dayWorkingMinutes) : '-'}
            </td>
            <td styleName={(dataRecordClassName === 'table-data-item') ? `${dataRecordClassName}-left` : dataRecordClassName}>
              {renderDescription(report)}
            </td>
          </tr>
    )
    })
  }

  return (
      <>
        <table styleName="sheet-report-table">
          <thead>
          <tr>
            <th styleName="table-header-item-fixed">日付</th>
            <th styleName="table-header-item-fixed">業務開始</th>
            <th styleName="table-header-item-fixed">業務終了</th>
            <th styleName="table-header-item-fixed">休憩</th>
            <th styleName="table-header-item-fixed">作業時間</th>
            <th styleName="table-header-item">業務内容</th>
          </tr>
          </thead>
          <tbody>
          {dailyReports(props.monthlyWorkReport.projectMonthlyTerm.targetMonth, props.monthlyWorkReport.dailyWorkReports) }
          </tbody>
        </table>
      </>
  )
}, styles)

export default ClientMonthlyWorkReportDetailSheet
